import React, { FC } from 'react';
import { useGetUserNotificationsCount } from 'api/userNotification.api';
import useMenuState from 'common/hooks/useMenuState';
import UserNotificationsBtn from 'components/Header/components/UserNotificationsBtn';
import UserNotificationsContentProvider from 'components/Header/components/UserNotificationsContentProvider';

const UserNotificationsContainer: FC = () => {
  const { menuAnchorEl, handleShowMenu, handleCloseMenu } = useMenuState();
  const { data } = useGetUserNotificationsCount();

  return (
    <>
      <UserNotificationsBtn onClick={handleShowMenu} count={data} />

      {menuAnchorEl ? (
        <UserNotificationsContentProvider menuAnchorEl={menuAnchorEl} onClose={handleCloseMenu} />
      ) : null}
    </>
  );
};

export default UserNotificationsContainer;
